import { Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { RequestTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { RequestFormParticipants } from '@omnea-app/requests/requestsHttpClient'

interface CommentDefaultEmptyStateProps {
  requestFormParticipants?: RequestFormParticipants
}
export const CommentDefaultEmptyState = ({ requestFormParticipants }: CommentDefaultEmptyStateProps) => {
  const { t } = useTranslation('requests')
  const theme = useTheme()

  if (!requestFormParticipants) {
    return <span>{t('request-comments.no-comments')}</span>
  }

  const { request, requestor, requestOwner, businessOwner } = requestFormParticipants

  const requestorName = requestor ? `${requestor.firstName} ${requestor.lastName}` : ''

  const requestOwnerName = requestOwner ? `${requestOwner.firstName} ${requestOwner.lastName}` : ''

  const businessOwnerName = businessOwner ? `${businessOwner.firstName} ${businessOwner.lastName}` : ''

  if (
    [
      RequestTypeEnum.ACCESS_REQUEST,
      RequestTypeEnum.NEW_PURCHASE,
      RequestTypeEnum.CATALOGUE_PURCHASE,
      RequestTypeEnum.RENEWAL,
    ].includes(request.type)
  ) {
    return requestor || requestOwnerName ? (
      <span style={{ lineHeight: '20px', color: theme.palette.neutralLight[900] }}>
        <Typography variant="Body14pxRegular">{t('request-comments.empty-external-tab.message')}</Typography>
        <br />
        {requestorName && (
          <Typography fontWeight={theme.typography.fontWeightBold} variant="Body14pxRegular">
            {t('request-comments.empty-external-tab.user', {
              user: `${requestorName}`,
            })}
          </Typography>
        )}
        {requestorName && requestOwnerName && requestOwner?.id !== requestor?.id && (
          <Typography variant="Body14pxRegular"> {t('request-comments.empty-external-tab.or')} </Typography>
        )}
        {requestOwnerName && requestOwner?.id !== requestor?.id && (
          <Typography fontWeight={theme.typography.fontWeightBold} variant="Body14pxRegular">
            {t('request-comments.empty-external-tab.user', {
              user: `${requestOwnerName}`,
            })}
          </Typography>
        )}
      </span>
    ) : (
      <span>
        <Typography color="neutralLight.900" variant="Body14pxRegular">
          {t('request-comments.no-comments')}
        </Typography>
      </span>
    )
  } else {
    return businessOwner || requestOwnerName ? (
      <span style={{ lineHeight: '20px', color: theme.palette.neutralLight[900] }}>
        <Typography variant="Body14pxRegular">{t('request-comments.empty-external-tab.message')} </Typography>
        <br />
        {businessOwnerName && (
          <Typography fontWeight={theme.typography.fontWeightBold} variant="Body14pxRegular">
            {t('request-comments.empty-external-tab.user', {
              user: `${businessOwnerName}`,
            })}
          </Typography>
        )}
        {businessOwnerName && requestOwnerName && (
          <Typography variant="Body14pxRegular"> {t('request-comments.empty-external-tab.or')} </Typography>
        )}
        {requestOwnerName && (
          <Typography fontWeight={theme.typography.fontWeightBold} variant="Body14pxRegular">
            {t('request-comments.empty-external-tab.user', {
              user: `${requestOwnerName}`,
            })}
          </Typography>
        )}
      </span>
    ) : (
      <span>
        <Typography color="neutralLight.900" variant="Body14pxRegular">
          {t('request-comments.no-comments')}
        </Typography>
      </span>
    )
  }
}
